import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

// Password input with an accessible show/hide toggle.
// Toggles between type password/text without ever mutating the value,
// stays password-manager compatible, and never logs the value.
export const PasswordInput = React.forwardRef(function PasswordInput(
  { className = "", "data-testid": testId, ...props },
  ref
) {
  const [show, setShow] = useState(false);
  return (
    <div className={`relative ${className}`}>
      <Input
        ref={ref}
        type={show ? "text" : "password"}
        data-testid={testId}
        className="pr-10"
        {...props}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 focus:outline-none"
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});
